import * as Sentry from "@sentry/react"
import { createRoot } from "react-dom/client"

import App from "./App.tsx"
import SentryErrorBoundary from "./components/SentryErrorBoundary"
import "./index.css"

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://43b52277d2227f0494d1e6ca2f114477@o4507254072213504.ingest.de.sentry.io/4511660694503504",
    dataCollection: {
      userInfo: false,
      httpBodies: [],
    },
    tracesSampleRate: 1.0,
  })
}

const container = document.getElementById("root")
const root = createRoot(container!)
root.render(
  <SentryErrorBoundary>
    <App />
  </SentryErrorBoundary>,
)
